import { BaseWidgetEntityWithWellId } from './BaseWidgetEntityWithWellId';

export abstract class WidgetWithEditMode extends BaseWidgetEntityWithWellId {
  abstract setEditMode(isEditMode: boolean): void;
  abstract get isEditMode(): boolean;
}
